var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { IconDropdown } from "../..";
import { useToggle } from "../../../hooks";
import { ApplicationMenuButton } from './ApplicationMenuButton';
import { MenuIcon } from './MenuIcon';
export var ApplicationMenu = function (_a) {
    var _b = _a.applications, applications = _b === void 0 ? [] : _b;
    var _c = __read(useToggle(), 2), isOpen = _c[0], onToggle = _c[1];
    if (!applications.length) {
        return null;
    }
    return (React.createElement(IconDropdown, { id: "application-dropdown-menu", icon: React.createElement(MenuIcon, null), isOpen: isOpen, onToggle: onToggle, ariaLabel: "Application Menu", showArrow: true, arrowColor: "white", contentProps: {
            position: 'left',
            lss: {
                display: 'flex',
                flexDirection: 'column',
                px: 'sm',
                py: 'lg'
            }
        } }, applications.map(function (_a) {
        var appName = _a.application_name, url = _a.landing_page_url;
        var appId = "app-menu-button-" + appName
            .replace(/\s/g, '-')
            .toLowerCase();
        return (React.createElement(ApplicationMenuButton, { key: appId, id: appId, url: url, appName: appName }));
    })));
};
//# sourceMappingURL=ApplicationMenu.js.map